// The following are links detailing how to embed the Forethought widget:
// https://support.forethought.ai/hc/en-us/articles/1500002917301-Guide-to-Embedding-the-Solve-Widget-on-a-Web-Page
// https://support.forethought.ai/hc/en-us/articles/14239088125459-Solve-Widget-UI-Guide-for-Developers#h_01HXJGY8N0WTT6BAC7KJ9G3S66
// #forethought-acorns slack channel is also available for future assistance if needed
import { ENV } from '@acorns/web-utils'

const FORETHOUGHT_EMBED_URL = 'https://solve-widget.forethought.ai/embed.js'

export const loadForethoughtScript = (
  email: string,
  setIsForethoughtWidgetLoaded: (value: boolean) => void,
) => {
  const script = document.createElement('script')
  script.setAttribute('src', FORETHOUGHT_EMBED_URL)
  script.setAttribute('type', 'application/javascript')
  script.setAttribute('data-api-key', process.env.FORETHOUGHT_API_KEY ?? '')
  script.setAttribute('data-ft-email', email)
  script.setAttribute('hidden', 'true')
  script.setAttribute('data-ft-supports-salesforce', 'true')
  script.onload = () => {
    window.Forethought('widget', 'hide')
    setIsForethoughtWidgetLoaded(true)
  }

  document.head.appendChild(script)
}

export const loadSalesforceChat = (
  setIsSalesforceChatLoaded: (value: boolean) => void,
) => {
  const script = document.createElement('script')

  if (process.env.BUILD_ENV === ENV.Production) {
    script.setAttribute(
      'src',
      'https://acorns.my.site.com/ESWAcornsWebMessaging1729015171597/assets/js/bootstrap.min.js',
    )
    script.setAttribute('type', 'text/javascript')
    script.onload = () => {
      window.embeddedservice_bootstrap.settings.language = 'en_US'
      window.embeddedservice_bootstrap.init(
        '00Da500000WglrQ',
        'Acorns_Web_Messaging',
        'https://acorns.my.site.com/ESWAcornsWebMessaging1729015171597',
        {
          scrt2URL: 'https://acorns.my.salesforce-scrt.com',
        },
      )
    }
  } else {
    script.setAttribute(
      'src',
      'https://acorns--uat.sandbox.my.site.com/ESWAcornsWebMessaging1729015171597/assets/js/bootstrap.min.js',
    )
    script.setAttribute('type', 'text/javascript')
    script.onload = () => {
      window.embeddedservice_bootstrap.settings.language = 'en_US'
      window.embeddedservice_bootstrap.init(
        '00DWC000002SUd7',
        'Acorns_Web_Messaging',
        'https://acorns--uat.sandbox.my.site.com/ESWAcornsWebMessaging1729015171597',
        {
          scrt2URL: 'https://acorns--uat.sandbox.my.salesforce-scrt.com',
        },
      )
    }
  }

  setIsSalesforceChatLoaded(true)

  document.head.appendChild(script)
}

export const openForethoughtWidget = () => {
  window.Forethought('widget', 'show')
  window.Forethought('widget', 'open')
}
export const removeForethoughtListener = () => {
  window.removeEventListener('message', () => {})
}
